/**
 * @author Nelson
 */
export class ImageContentType {
    static Png = "image/png";
    static Jpeg = "image/jpeg";
    static Jpg = "image/jpg";
}